var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"loginGoogle",staticClass:"btn btn-sm btn-google rounded-pill btn-block text-white"},[_c('i',{staticClass:"fab fa-google mr-1"}),_vm._v(" Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }